import {formatAddress} from 'presentation/utils';
import {ExamProviderLocation} from 'domain/usecases';
import {ExamUnits} from '../types';
import {ADVANCE_UNIT_CODE} from 'presentation/modules/booking/shared/constants/advanceUnit';

export const parseExamUnits = (units: ExamProviderLocation[]): ExamUnits[] =>
	units?.map(unit => ({
		code: unit?.codigo?.toString(),
		name: unit?.nome || unit?.nomeMedico || unit?.nmPrestador,
		stateCode: unit?.cdUf,
		city: unit?.nmCidade,
		addressNumber: unit?.numero?.toString(),
		addressName: unit?.logradouro,
		addressComplement: unit?.complemento,
		district: unit?.bairro,
		cep: unit?.cep,
		latitude: unit?.latitude,
		longitude: unit?.longitude,
		distance: unit?.distancia,
		nmBairroOrigem: unit?.nmBairroOrigem,
		formattedAddress: formatAddress({
			state: unit?.cdUf,
			city: unit?.nmCidade,
			number: unit?.numero?.toString(),
			address: unit?.logradouro,
			complement: unit?.complemento,
			district: unit?.bairro,
			zipCode: unit?.cep,
		}),
		isAdvanceUnit: unit?.codigo?.toString() === ADVANCE_UNIT_CODE,
	}));
